<template>
    <div class="turnee">
        <div class="">
            <div class="size100">
                <div class="fullsize" v-if="showIframe"/>
            </div>
            <div class="iframe-wrapper size100" v-bind:class="{ ui_expanded, ui_collapsed}">
                <vue-friendly-iframe
                    v-if="showIframe"
                    ref="iframeEl"
                    :style="{ 'display' : iframeLoading ? 'none' : 'block'}"
                    :src="iframeUrl"
                    :name="'ACClientIframe'"
                    @load="onLoad"
                    @iframe-load="onIframeLoad"
                    @urlEvent="onUrlEvent"
                    frameborder="0"
                    gesture="media"
                    crossorigin="use-credentials"
                    sandbox="allow-forms allow-same-origin allow-scripts allow-top-navigation"
                    allow="encrypted-media">
                </vue-friendly-iframe>
            </div>
        </div>
        <div class="zdj_controls">
            <!--      <div v-if="state==='initiating'" key="iframe-loading">-->
            <!--        &lt;!&ndash;                Zone-de-joc {{state}}&ndash;&gt;-->
            <div v-if="viewState==='signup' && !logginIn &&!loggedIn">
                <div class="auth-block-wrapper">
                    <div class="auth-block">
                        <span class="auth-block-header">{{$t("tournaments.LBL_USERNAME_FORM_FIELD_NAME")}}</span>
                        <span class="auth-block-text">{{$t("tournaments.LBL_USERNAME_FORM_HELPER")}}</span>
                        <div class="form">
                            <label>
                                <input v-model="zdjLogin" :placeholder="$t('tournaments.LBL_USERNAME_FORM_FIELD')">
                            </label>
                            <button class="button" @click="onClickSignup">
                                {{$t("tournaments.LBL_FORM_LOGIN_BUTTON")}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <LoadingIndicator
                v-if="logginIn" class="primary big"
            />
            <!--      </div>-->
        </div>
        <ZDJErrorPopup
            name="zdjErrorPopup"
            title="Eroare"
            :description="error && error.toString() || ''"
            :show="error !== undefined && error !=='' "
            @closepopup="onCloseError"
        />
    </div>
</template>

<style lang="scss">
    @import "style.scss";
</style>

<script>
    import { mapState } from "vuex";
    import zdjService from '@/services/zdj/zdjService';
    import ZDJErrorPopup from './popups/ZDJErrorPopup';
    import LoadingIndicator from "@/components/LoadingIndicator/LoadingIndicator";
    import VueFriendlyIframe from '@/components/FriendlyIframe';

    export default {
    name: 'ZDJPage',
    components: {ZDJErrorPopup, VueFriendlyIframe, LoadingIndicator},
    props: [
        'targetUri', //tournament
    ],
    computed: {
        ...mapState('zdj', [
            'loggedIn',
            'registered',
            'logginIn',
            'error',
        ]),
        ...mapState('ui', [
            'sidebarExpanded',
        ])
    },
    watch: {
        loggedIn: function (newLoggedIn, oldLoggedIn) {
            if (newLoggedIn === true)
                this.showPage()
            else
                this.hidePage()
        },
        logginIn: function (newV, oldV) {
            if (oldV && !newV) {
                if (!this.loggedIn) {
                this.hidePage();
                } else {
                this.showPage();
                }
            }
        },
        sidebarExpanded: function (newV, oldV) {
            this.ui_expanded = newV
            this.ui_collapsed = !newV
        }
    },
    data() {
        return {
            iframeUrl: '',
            iframeLoading: true,
            viewState: 'initiating',
            zdjLogin: '',
            //error: null,
            showIframe: false,
            initiatingPoll: false,
            loading: false,
            ui_expanded: true,
            ui_collapsed: false,
            targetUrl: this.targetUri,
        }
    },
    created() {
        // console.log('turnee created', this.targetUrl);

        if (this.loggedIn) {
        // console.log('loggedIn')
        this.showPage();
        } else {
        if (this.logginIn || this.registered)
            this.hidePage();
        else
            this.showSignupForm();
        }
        // zdjService.getCredentials()
        //     .then(data => {
        //       if (!data.p) {
        //         this.showSignupForm();
        //       } else {
        //         this.proceedWithLogin(data)
        //       }
        //     })
        //     .catch(err => {
        //       // console.log(err)
        //       this.error = err;
        //     })
        // ;
    },
    beforeDestroy() {
        // if (this.initiatingPoll && this.initiatingPoll.cancel) {
        //     // console.log("Cancelling initiatingPoll")
        //     this.initiatingPoll.cancel();
        // }
    },
    methods: {
        showPage() {
        this.state = 'showPage';
        console.log("!!!!!!!!!!!!!", this.targetUri, this.targetUri.replace( "---coordinate", "/coordinate"))
        this.iframeUrl = zdjService.getIframeUrl(this.targetUri.replace( "---coordinate", "/coordinate"));
        this.showIframe = true;
        this.iframeLoading = false;

        },
        hidePage() {
        this.state = 'hidePage';
        this.showIframe = false;
        this.iframeLoading = false;
        this.iframeUrl = '';
        // console.log('notLoggedIn')
        // console.log('this.logginIn', this.logginIn)
        // console.log('this.registered', this.registered)
        // console.log('this.error', this.error)
        if (!this.registered && !this.logginIn) {
            // console.log('sowing registered')
            this.showSignupForm();
        }

        },
        // translate(errorDesc) {
        //   switch (errorDesc) {
        //     case "No access for no user" : return "No access for no user"
        //     default:
        //         return errorDesc;
        //   }
        // },
        showSignupForm() {
        // // console.log('ShowSignuP')
        this.viewState = "signup"
        },
        onClickSignup() {
        if (this.zdjLogin) {
            this.$store.dispatch('zdj/register', this.zdjLogin);
        }
        },
        onCloseError() {
        // this.error = undefined;
        this.$store.commit('zdj/clearErrors');
        },
        onLoad() {
        // console.log('turnee: iframe loaded onLoad');
        // this.iframeLoading = false;
        },
        onIframeLoad() {
        },
        onReadyToLogin() {
        },
        onUrlEvent(url) {
        if (url && url.length && url.length >= zdjService.getZDJUrl().length) {
            const newUrl = url.substring(zdjService.getZDJUrl().length);
            // console.log('newUrl:' + newUrl);
            console.log('-->>> this.targetUrl:' + this.targetUrl);
            console.log('this.targetUri:' + this.targetUri);
            if (newUrl !== this.targetUrl) {
            this.targetUrl = newUrl;
            //TODO: should propogae title too
            history.pushState({}, null, "/gamezone/" + newUrl
                .replace(/^\/*/g, '')
                .replace("/coordinate","---coordinate"));
    //          this.$router.replace('/gamezone/' + newUrl.replace(/^\/*/g, ''));
            } else {
            // console.log('equals')
            }
        } else {
            // console.log("Unexpected url from zone:", url)
        }
        },
    }
    }
</script>
